import { useCallback, useState } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { Feedback } from "@models";
import { HiHandThumbDown, HiHandThumbUp, HiOutlineHandThumbDown, HiOutlineHandThumbUp } from "react-icons/hi2";

const AiResultFeedback: FCX<{
    onFeedbackClick?: (feedback: Feedback) => void;
}> = ({
    onFeedbackClick,
    className,
    testId,
}) => {
    const [feedback, setFeedback] = useState<Feedback>(Feedback.None);

    const handleFeedbackChange = useCallback((feedback: Feedback) => {
        setFeedback(feedback);
        onFeedbackClick?.(feedback);
    }, [onFeedbackClick]);

    const clearFeedback = useCallback(() => handleFeedbackChange(Feedback.None), [handleFeedbackChange]);
    const positiveFeedback = useCallback(() => handleFeedbackChange(Feedback.Up), [handleFeedbackChange]);
    const negativeFeedback = useCallback(() => handleFeedbackChange(Feedback.Down), [handleFeedbackChange]);

    return (
        <div
            className={cn(
                "AiResultFeedback",
                className
            )}
            data-testid={testId ?? "blockAiResultFeedback"}
        >
            <span
                className="AiResultFeedback__label"
                data-testid="textAiResultFeedbackLabel"
            >Was this answer helpful?</span>
            <div className="AiResultFeedback__icons">
                {feedback === Feedback.Up ?
                    <HiHandThumbUp
                        className="AiResultFeedback__icon is-like-icon"
                        onClick={clearFeedback}/> :
                    <HiOutlineHandThumbUp
                        className="AiResultFeedback__icon is-like-icon"
                        onClick={positiveFeedback}
                    />}
                {feedback === Feedback.Down ?
                    <HiHandThumbDown
                        className="AiResultFeedback__icon is-dislike-icon"
                        onClick={clearFeedback}/> :
                    <HiOutlineHandThumbDown
                        className="AiResultFeedback__icon is-dislike-icon"
                        onClick={negativeFeedback}
                    />}
            </div>
        </div>
    );
};

export default AiResultFeedback;